import { yup } from '@framework/validation';
import { Datatype } from '../../../../expressions/datatype/Datatype';
import { SwitchExpressionSchema } from '../../../../expressions/repository/switch-expression/SwitchExpressionSchema';
import { WidgetType } from '../../../Widget';
import { BaseLayoutSchema } from '../../common/BaseLayoutSchema';
import { CommonInputWidgetConfigSchema } from '../../inputs/common/CommonInputConfigComponent';
import { ISwitchWidget } from './ISwitchWidget';

export const SwitchWidgetConfigSchema: yup.ObjectSchema<ISwitchWidget> =
  CommonInputWidgetConfigSchema.shape({
    type: yup.string().exact(WidgetType.Switch).required(),
    expression: SwitchExpressionSchema.required(),
    layout: BaseLayoutSchema.shape({
      hide: yup.boolean().required().default(false).label('Nascondi elemento'),
      removeBorder: yup
        .boolean()
        .required()
        .default(false)
        .label('Rimuovi bordo'),
    }),
    datatype: yup
      .string()
      .required()
      .oneOf([
        Datatype.Number,
        Datatype.Boolean,
        Datatype.Date,
        Datatype.String,
      ])
      .label('Tipo di dato'),
  });
